import React from 'react';
import {
  Badge, mergeClasses, Text, TextProps,
} from '@fluentui/react-components';

import { useCardErrorContext } from '../contexts/error';
import { useCommonComponentsStyles } from './common-components-styles';

export const FormCardTitle: React.FC<React.PropsWithChildren<Partial<TextProps>>> = ({ children, ...rest }) => {
  const classes = useCommonComponentsStyles();

  return (
    <Text
      {...rest as any}
      className={mergeClasses('card-title', classes.title)}
    >
      {children}
    </Text>
  );
};

export const FormCardError: React.FC = () => {
  const { error } = useCardErrorContext();

  if (!error) {
    return null;
  }

  return (
    <Badge
      className="card-error"
      appearance="tint"
      size="large"
      shape="rounded"
      color="danger"
    >
      {error}
    </Badge>
  );
};

export const Spacer: React.FC = () => {
  const classes = useCommonComponentsStyles();

  return (
    <div className={classes.spacer} />
  );
};
